import {
    CompetitorsMediaInvestmentQueryArgs,
    GetCompetitorsMediaInvestmentResponse,
} from '@/dashboards/CompetitorsMediaInvestment/types';
import { competitorMediaInvestmentQueries } from '@/duckdb/competitor-media-investment';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export type CompetitorsMediaInvestmentDataKeys = {
    category: string;
    variable: string;
    investment: string;
    date: string;
};

const getCompetitorsMediaInvestmentDataKeys = (
    results: GetCompetitorsMediaInvestmentResponse,
) => {
    const keyMap: CompetitorsMediaInvestmentDataKeys = {
        category: '',
        variable: '',
        investment: '',
        date: '',
    };

    Object.entries(results.fields).forEach(([key, value]) => {
        if (value.name === 'period_name_day') {
            keyMap.date = key;
        } else {
            keyMap[value.name] = key;
        }
    });

    return keyMap;
};

const modifyCompetitorsMediaInvestmentResponse = (
    data: GetCompetitorsMediaInvestmentResponse,
) => {
    const keyMap = getCompetitorsMediaInvestmentDataKeys(data);

    return {
        fieldKeys: keyMap,
    };
};

const fetchCompetitorsMediaInvestmentFromDb = async ({
    competitorVariables,
}: {
    competitorVariables: string[];
}) => {
    const { rows, missingVariables } =
        await competitorMediaInvestmentQueries.getCompetitorInvestmentRows(
            competitorVariables,
        );

    const data = {
        availablePeriods: ['daily', 'weekly', 'monthly', 'quarterly', 'yearly'],
        period: null,
        fields: {
            category: {
                label: 'Category',
                name: 'category',
                type: 'string',
            },
            variable: {
                label: 'Variable',
                name: 'variable',
                type: 'string',
            },
            investment: {
                label: 'Investment',
                name: 'investment',
                type: 'number',
            },
            period: {
                label: 'Period',
                name: 'period',
                type: 'date',
            },
            period_name_day: {
                label: 'Period Name',
                name: 'period_name_day',
                type: 'string',
            },
        },
        rows,
    };

    return {
        ...data,
        missingVariables,
        ...modifyCompetitorsMediaInvestmentResponse(
            data as GetCompetitorsMediaInvestmentResponse,
        ),
    };
};

export const modelCompetitorsMediaInvestmentOptions = ({
    competitorVariables,
}: CompetitorsMediaInvestmentQueryArgs) =>
    queryOptions({
        queryKey: ['competitorsMediaInvestment', competitorVariables],
        queryFn: async () => {
            return fetchCompetitorsMediaInvestmentFromDb({
                competitorVariables,
            });
        },
        placeholderData: keepPreviousData,
        staleTime: Infinity,
    });
